import { useMutation } from '@tanstack/react-query';
import { saveAccountOpeningReason } from '../api/accountOpeningReason';
import { useNavigationManager } from '@Router/useNavigationManager';

export const useSendAccountOpeningReason = () => {
  const { navigateToNextPage } = useNavigationManager();
  return useMutation({
    mutationFn: saveAccountOpeningReason,
    mutationKey: ['saveAccountOpeningReason'],
    onSuccess: () => {
      navigateToNextPage();
    },
  });
};
